import React from "react";
import i18next from "i18next";
import { Trans } from "react-i18next";
import getUnicodeFlagIcon from "country-flag-icons/unicode";
import getCountryISO2 from "country-iso-3-to-2";

import { getSetting } from "../components/Settings/InstallationSettings";
import i18n from "../i18n";
import { Icon, Tag } from "@blueprintjs/core";

//take an amount (float) and return the formatted amount
export function mefMontant(mt = 0, devise = 1) {
  let currency = getSetting("currency");
  if (devise === 2) currency = getSetting("currency2");
  const str = new Intl.NumberFormat(i18next.language, {
    style: "currency",
    currency: currency,
  }).format(mt / 100);
  return <div className="amount">{str}</div>;
}

let currency_symbol = undefined;

export function getCurrencySymbol() {
  if (currency_symbol === undefined)
    currency_symbol = new Intl.NumberFormat("EN-US", {
      style: "currency",
      currency: getSetting("currency"),
    })
      .format(0)
      .split("0")[0];
  return currency_symbol;
}

export function mefMontantStr(mt) {
  var str = "";
  if (!isNaN(mt))
    str = new Intl.NumberFormat(i18next.language, {
      style: "currency",
      currency: getSetting("currency"),
    }).format(mt / 100);
  return str;
}

export function mefState(synthese) {
  var ret = "unknown";
  switch (synthese) {
    case 0:
      ret = <Trans>working</Trans>;
      break;
    case 1:
      ret = <Trans>out of order</Trans>;
      break;
    case 2:
      ret = <Trans>failure</Trans>;
      break;
    case 3:
      ret = <Trans>disconnected</Trans>;
      break;
    default:
      ret = <Trans>unknown</Trans>;
  }
  return ret;
}

const plate_format_FRA_SIV = new RegExp(
  "^(?!.[IOU]|[IOU].)([A-Z]{2})[-\\s]?(\\d{3})[-\\s]?(?!.[IOU]|[IOU].)([A-Z]{2})$"
);

const plate_format_FRA_FNI = new RegExp(
  "^[0-9]{2,4}[\\s-]{0,1}[A-Z]{1,3}[\\s-]{0,1}([0-9]{2}|2A|2B)$"
);

export function mefPlate(plate) {
  if (plate === "UNKNOWN" || plate === undefined) return "";
  else if (plate_format_FRA_SIV.test(plate))
    return (
      plate.substring(0, 2) +
      "-" +
      plate.substring(2, 5) +
      "-" +
      plate.substring(5, 8)
    );
  else if (plate_format_FRA_FNI.test(plate)) {
    // 2 or 3 first numbers
    const str_part = plate
      .split("")
      .filter((char) => isNaN(char))
      .join("");
    const formatted =
      plate.split(str_part)[0] +
      " " +
      str_part +
      " " +
      plate.split(str_part)[1];
    if (plate.length + 2 === formatted.length)
      // plate + 2 spaces
      return formatted;
    else return plate; // exotic formats (like corse 2A 2B)
  } else return plate;
}

export function mefDate(raw) {
  if (typeof raw === "string" && raw.length === 14) {
    const date = new Date(
      raw.substring(0, 4),
      raw.substring(4, 6) - 1,
      raw.substring(6, 8),
      raw.substring(8, 10),
      raw.substring(10, 12),
      raw.substring(12, 14)
    );
    return date.toLocaleString(i18next.language);
  } else if (typeof raw === "string" && raw.length === 12) {
    const date = new Date(
      "20" + raw.substring(0, 2),
      raw.substring(2, 4),
      raw.substring(4, 6),
      raw.substring(6, 8),
      raw.substring(8, 10),
      raw.substring(10, 12)
    );
    return date.toLocaleString(i18next.language);
  } else if (raw instanceof Date && !isNaN(raw))
    return raw.toLocaleString(i18next.language);
  else if (!isNaN(Date.parse(raw)))
    return new Date(raw).toLocaleString(i18next.language);
  else return raw;
}

export function mefInterval(seconds) {
  var levels = [
    [Math.floor(seconds / 31536000), i18n.t("years")],
    [Math.floor((seconds % 31536000) / 86400), i18n.t("days")],
    [Math.floor(((seconds % 31536000) % 86400) / 3600), i18n.t("hours")],
    [
      Math.floor((((seconds % 31536000) % 86400) % 3600) / 60),
      i18n.t("minutes"),
    ],
    [
      Math.floor((((seconds % 31536000) % 86400) % 3600) % 60),
      i18n.t("seconds"),
    ],
  ];
  var returntext = "";

  for (var i = 0, max = levels.length; i < max; i++) {
    if (levels[i][0] === 0) continue;
    returntext +=
      " " +
      levels[i][0] +
      " " +
      (levels[i][0] === 1
        ? levels[i][1].substr(0, levels[i][1].length - 1)
        : levels[i][1]);
  }
  return returntext.trim();
}

export function mefTime(miliseconds) {
  const m = Math.floor(miliseconds / 1000 / 60) + "";
  const s = Math.floor((miliseconds - m * 1000 * 60) / 1000) + "";
  return m.padStart(2, "0") + ":" + s.padStart(2, "0");
}

export function largo2sqlDate(date) {
  if (date && date.length === 6) {
    //1995-12-17
    //return ('20' + date.substr(0, 2) + '-' + date.substr(4, 2) + '-' + date.substr(2, 2));
    return date.substr(0, 2) + date.substr(2, 2) + date.substr(4, 2);
  } else if (date && date.length === 14)
    return (
      date.substr(0, 4) +
      "-" +
      date.substr(4, 2) +
      "-" +
      date.substr(6, 2) +
      " " +
      date.substr(8, 2) +
      ":" +
      date.substr(10, 2) +
      ":" +
      date.substr(12, 2)
    );
  else if (date && date.length === 12)
    return (
      date.substr(0, 4) +
      "-" +
      date.substr(4, 2) +
      "-" +
      date.substr(6, 2) +
      " " +
      date.substr(8, 2) +
      ":" +
      date.substr(10, 2) +
      ":00"
    );
  else if (date.length === 0) return "";
  else {
    console.log("invalid date: " + date);
    return date;
  }
}

export const userColors = {
  0: "#2596be", // ticket
  1: "lightblue", //credit card
  2: "goldenrod", // subscriber
  3: "goldenrod", // subscriber
  10: "darkgreen", // resa
};

export const userIcons = {
  0: "widget-footer", // ticket
  1: "credit-card", //credit card
  2: "id-number", // subscriber
  3: "id-number", // subscriber
  10: "book", // resa
  20: "barcode",
  80: "segmented-control", // immat
  82: "id-number", // abocor
};

export function getExtension(format) {
  switch (format) {
    case "csv":
      return "csv";
    case "html":
      return "html";
    default:
    case "excel":
      return "xlsx";
  }
}

export function mefCountry(iso_3166) {
  if (!iso_3166 || iso_3166 === "")
    return (
      <span>
        <Icon icon="help" /> <Trans>unknown</Trans>
      </span>
    );

  const locales = new Intl.DisplayNames([i18n.language || "en"], {
    type: "region",
  });

  let flag;
  let cntry_name = iso_3166;
  try {
    flag = getUnicodeFlagIcon(getCountryISO2(iso_3166) || iso_3166);
    try {
      cntry_name = locales.of(getCountryISO2(iso_3166));
    } catch {}
  } catch {}

  if (iso_3166.length === 3)
    return (
      <span>
        {flag} {cntry_name}
      </span>
    );
  else return iso_3166;
}

export function mefBrand(brand) {
  if (!brand || brand === "") return;
  else
    return (
      <span>
        <img
          src={"/ow/view/pictures/vehicle_brands/" + brand + ".SVG"}
          alt={brand}
          style={{ maxHeight: "2ch", maxWidth: "2ch" }}
        />{" "}
        {brand.charAt(0).toUpperCase() + brand.slice(1).toLowerCase()}
      </span>
    );
}

export function mefColor(color) {
  if (!color || color === "")
    return (
      <span>
        <Icon icon="help" /> <Trans>unknown</Trans>
      </span>
    );
  else
    return (
      <Tag
        style={{
          backgroundColor: color.toLowerCase(),
          color: color === "WHITE" ? "black" : "white",
          border: "solid black 1px",
        }}
      >
        <Trans>{color}</Trans>
      </Tag>
    );
}

export function mefVehicleClass(v_class) {
  let icon = "";
  switch (v_class?.match?.label || v_class.label) {
    case "CAR":
    case "SALOONCAR":
    case "SUV":
    case "SALOONCAR":
    case "PICKUP":
    case "MPV":
    case "MICROBUS":
    case "VAN":
      icon = "drive-time";
      break;

    case "TRUCK":
    case "MICROTRUCK":
    case "MIDTRUCK":
    case "LARGETRUCK":
    case "BUS":
      icon = "truck";
      break;

    case "MOTORCYCLE":
    case "MOTORBIKE":
    case "BICYCLE":
      icon = "cycle";
      break;

    case "TAXI":
      icon = "taxi";
      break;
  }

  let orig = "";
  if (
    v_class?.match?.label &&
    i18n.t(v_class.label) !== i18n.t(v_class?.match?.label)
  )
    orig = (
      <>
        {" "}
        (<Trans>{v_class.label}</Trans>)
      </>
    );

  return (
    <>
      <Icon icon={icon || "blank"} />{" "}
      <Trans>{v_class?.match?.label || v_class.label}</Trans>
      {orig}
    </>
  );
}
